import { Vector3 as t, Quaternion as c } from "three";
const i = (r) => {
  const o = new t(), e = new c(), n = new t();
  return r.decompose(o, e, n), { position: o, quaternion: e, scale: n };
};
export {
  i as DecomposeMatrix
};
//# sourceMappingURL=index6.js.map
